import { useEffect } from 'react';
/**
 * Variation of the useEffect hook that only runs on unmount.
 */ export const useUnmountEffect = (callback)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(()=>callback
    , []);
};
